module.exports = __webpack_public_path__ + "static/media/TRB.1838f052.svg";